import {
  CREATE_CUSTOMER_PREFERENCE,
  DELETE_CUSTOMER_PREFERENCE,
  EDIT_CUSTOMER_PREFERENCE,
  RECEIVE_CUSTOMER_PREFERENCES,
  REQUEST_CUSTOMER_PREFERENCE,
} from '@sophocles/entities/CustomerPreference/customerPreferenceActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_CUSTOMER_PREFERENCES: // Read
      return state.merge(action.customerPreferences);
    case DELETE_CUSTOMER_PREFERENCE: // Delete
      return state.delete(action.customerPreferences);
    case EDIT_CUSTOMER_PREFERENCE: // Update
    case CREATE_CUSTOMER_PREFERENCE: // Create
    case REQUEST_CUSTOMER_PREFERENCE:
    default:
      return state;
  }
}

export function customerPreferenceReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_CUSTOMER_PREFERENCE:
    case DELETE_CUSTOMER_PREFERENCE:
    case RECEIVE_CUSTOMER_PREFERENCES:
    case EDIT_CUSTOMER_PREFERENCE:
    case REQUEST_CUSTOMER_PREFERENCE:
      return getState(state, action);
    default:
      return state;
  }
}
